





















































import Vue from 'vue'
import textareaInput from '@/components/Ui/Inputs/TextareaInputAutoHeight.vue'
import uiInput from '@/components/Ui/Inputs/StringInput.vue'
import {RawQuest} from '@/types/entity/RawPoll'
import questComponent from '../quest.vue'
import _ from 'lodash'
import Poll from '@/models/polls/Poll'
import {allUniq} from '@/lib/array'

// @ts-ignore
import messages from '@/lang/index';

const placeholders: {[key: string]: string} = {
  name: `${messages.polls.enter_poll_name} *`,
  descr: messages.polls.enter_poll_description
}

const emptyQuest: RawQuest = {
  text: messages.polls.question,
  required: false,
  items: [{text: messages.polls.variant_1}]
}

export default Vue.extend({
  name: 'FirstStep',
  props: {
    poll: {} as () => {poll: Poll}
  },
  components: {
    textareaInput,
    uiInput,
    questComponent
  },
  data () {
    return {
      title: '',
      descr: '',
      quests: [] as RawQuest[],
      error: false,
      activeQuest: 0,
      errorsQuest: [] as number[],
      placeholders: _.cloneDeep(placeholders),
    }
  },
  methods: {
    addQuest (index = 0) {
      this.quests.splice(index + 1, 0, _.cloneDeep(emptyQuest));
      this.setActiveQuest(index + 1);
    },
    removeQuest (index: number) {
      this.quests.splice(index, 1);
    },
    setActiveQuest (i: number) {
      this.activeQuest = i;
    },
    isActiveQuest (i: number) {
      return i === this.activeQuest;
    },
    isErrorQuest (index: number) {
      return this.errorsQuest.some(q => q === index)
    },
    validateQuests (): boolean {
      let isValid = true
      this.quests.forEach((quest, index) => {
        let items = []
        for (const item of quest.items) {
          items.push(item.text)
        }
        if (!allUniq(items)) {
          this.$message({
            // @ts-ignore
            message: this.$t('polls.question_variants_no_duplicate'),
            type: 'warning'
          });
          this.errorsQuest.push(index)
          this.setActiveQuest(index)
          isValid = false
        }
      })
      return isValid;
    },
    resetErrosQuest (): void {
      this.errorsQuest = []
    },
    validateTitle (): boolean {
      if (this.title) {
        return true
      } else {
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('polls.enter_poll_name'),
          type: 'warning'
        });
        return false
      }
    },
    next (): void {
      if (this.validateTitle() && this.validateQuests()) {
        this.$emit('next', {title: this.title, descr: this.descr, quests: this.quests})
      }
    },
    resetError (): void {
      this.error = false
    },
    onInput () {
      this.resetError()
    },
    onInputFocus (ref: string) {
      this.placeholders[ref] = ''
    },
    onInputBlur (ref: string) {
      this.placeholders[ref] = placeholders[ref]
    },
    onQuestOutsideClick () {
      this.activeQuest = -1;
    }
  },
  computed: {
    hideRemoveQuest (): boolean {
      if (this.quests.length <= 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted () {
    this.addQuest()
  },
  watch: {
    quests: {
      handler () {
        this.resetErrosQuest()
      },
      deep: true
    }
  }
})
